"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixFacetName = void 0;
const prefixFacetName = (facetFilter) => facetFilter.startsWith('attributes.') ? facetFilter : `attributes.${facetFilter}`;
exports.prefixFacetName = prefixFacetName;
//# sourceMappingURL=prefixFacetName.js.map